import { render, staticRenderFns } from "./BillingDetailSummaryStorageMultiWhIndex.vue?vue&type=template&id=2b4ab317&scoped=true&"
import script from "./BillingDetailSummaryStorageMultiWhIndex.vue?vue&type=script&lang=js&"
export * from "./BillingDetailSummaryStorageMultiWhIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingDetailSummaryStorageMultiWhIndex.vue?vue&type=style&index=0&id=2b4ab317&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ab317",
  null
  
)

export default component.exports